<script setup>
import { inject } from 'vue';

const character = inject('printCharacter');

defineProps({
  keyword: {
    type: String,
    required: true,
  },
});

const toTitleCase = (str) => str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
</script>

<template>
  <div class="special-attributes-section">
    <div class="special-attribute-table">
      <div class="title">
        {{ toTitleCase(keyword) }}s
      </div>
      <div class="list">
        <div v-for="attrib in character.specialAttributes.filter((a) => a.specialAttribute.attributeName.toLowerCase().includes(keyword.toLowerCase()))" :key="attrib._id" class="special-attribute-row">
          <div class="w3-col">
            <span class="name">{{ attrib.specialAttribute.attributeName }}</span>: <span class="desc">{{ attrib.notes }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.special-attributes-section {
  margin-top: 1px;
  display: inline-block;
  height: 100%;
  width: 100%;
  border: 1px solid lightgrey;
}

.special-attribute-table {
  display: inline-block;
  width: 100%;
}

.special-attribute-row {
  vertical-align: top;
  padding-left: 0.05in;
  padding-top: 0.05in;
  padding-bottom: 0.07in;
  border-bottom: 1px solid lightgrey;
}

.title {
  background-color: black;
  color: white;
  text-align: center;
}

.name {
  font-size: 1.2em;
  font-weight: bold;
}

.desc {
  font-style: italic;
  font-size: 1.1em;
  line-height: 0.8em;
}

</style>
